<!--
 * @Author: kongxiangyu
 * @Date: 2023-02-09 10:36:13
 * @LastEditTime: 2023-02-09 17:46:22
 * @email: kongxiangyu@cd.baidu.com
 * @Description: Do not edit
-->
<template>
    <div id="hot" class="hot">
        <div class="top"></div>
        <div class="box">
            <div
                v-for="item in list"
                :key="item.id"
                class="item"
                @click="jump(item.detail_url,item.product_id,'hot')"
            >
                <div class="item-top">
                    <img :src="item.pic_url" alt="">
                    <span class="location">
                        <img
                            class="location-img"
                            src="../../../assets/location.png"
                            alt=""
                        >
                        {{ item.distance }}
                    </span>
                </div>
                <div class="item-bottom">
                    <p class="title">{{ item.shop_name }}</p>
                    <p class="good">{{ item.product_name }}</p>
                    <div class="hot-bar">
                        <span class="rate">{{ item.discount_rate }}折</span>
                        <span class="stock">{{ text[Math.floor((Math.random() * text.length))] }}</span>
                    </div>
                    <div class="bottom-box">
                        <div class="price-box">
                            <span class="price-now">¥{{ item.baidu_discount_price / 100 }}</span>
                            <span class="price-prev">¥{{ item.origin_price / 100 }}</span>
                        </div>
                        <div class="btn">马上抢</div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
import {getParamsFromUrl} from '@baidu/map-fe-utils';
import Server from '../../../service.js';
import StatisticConst from '../../../constant/StatisticConst.js';
export default {
    props: {
        dataSource: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            list: [],
            text: ['限量抢购', '人气爆款', '物超所值', '口味超赞', '尖货推荐', '推荐尝试', '回味无穷', '天天优惠']
        };
    },
    created() {
        this.getGoodList();
    },
    methods: {
        onImgError(e) {
            e.target.src = require('../../../assets/default.png');
        },
        getGoodList() {
            const [loc_x, loc_y] = getParamsFromUrl().loc.replace('(', '').replace(')', '').split(',');
            const params = {
                activity_id: this.dataSource.card_data.product.product_activity_id,
                component_id: this.dataSource.card_data.product.product_option_id,
                loc_x: loc_x || '12947476.969463786',
                loc_y: loc_y || '4846478.119990898',
                is_local: 1,
                city_id: getParamsFromUrl().c || 131,
                biz: 'cater',
                room_id: this.dataSource.room_id,
                page_size: 100

            };
            // eslint-disable-next-line @babel/new-cap
            Server('GetGoodList', params)
                .then(res => {
                    if (res.errno === 0) {
                        res.data.product_list.sort(() => {
                            return 0.5 - Math.random();
                        });
                        this.list = res.data.product_list || [];
                    }
                })
                .catch(e => {
                    console.error(e.message);
                });
        },
        jump(url, id, module) {
            StatisticConst.goodsClick({
                id,
                module: 'jinribaokuan' + module
            });
            window.location.href = url;
        },
        /**
         * 点击查看更多
         */
        handleMoreXc() {
            this.list.direction = !this.list.direction;
        }
    }
};
</script>

<style lang="scss" scoped>
    .hot{
        margin-top:10px;
        .top{
            background: url(../../../assets/hot.png) no-repeat;
            background-size: 100% 100%;
            width: 340px;
            height: 53px;
            margin:0 auto 0px;
        }
        .box{
            width:calc(100% - 12px);
            margin-left:12px;
            display:flex;
            overflow-x: scroll;
            scrollbar-width: none;
                &::-webkit-scrollbar {
                    display: none;
            }
            .item{
                width:106px;
                min-height:100px;
                flex-shrink: 0;
                background:white;
                border-radius:6px;
                overflow: hidden;
                margin-right:8px;

                .item-top{
                    position:relative;
                    width:100%;
                    height:73px;
                    border-radius:6px;
                    overflow: hidden;
                    img{
                        width:100%;
                        height:100%;
                    }
                    .location{
                        position:absolute;
                        left:3px;
                        bottom:2px;
                        display: flex;
                        min-width:45px;
                        height: 15px;
                        background: rgba(0,0,0,0.4);
                        border-radius: 6px;
                        justify-content: flex-start;
                        align-items: center;
                        font-size: 11px;
                        font-family: PingFang SC;
                        font-weight: 300;
                        padding: 0 5px;
                        color: #FFF5F5;

                        .location-img{
                            width:8px;
                            height:8px;
                            margin-right:3px;
                        }
                    }
                }
                .item-bottom{
                    padding:7px 4px;
                    p{
                        width:100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    .title{
                        font-size: 10px;
                        font-family: Lantinghei SC;
                        font-weight: 600;
                        color: #5C6370;
                        line-height:12px;
                    }
                    .good{
                        font-size: 13px;
                        line-height:14px;
                        font-family: Lantinghei SC;
                        font-weight: 600;
                        color: #000000;
                        margin-top:5px;
                    }
                    .hot-bar{
                        width:97px;
                        height:18px;
                        position:relative;
                        background-image: url('../../../assets/hot-bar.png');
                        background-size:100% 100%;
                        display:flex;
                        justify-content: space-between;
                        margin-top:4px;
                        span{
                            display:block;
                        }
                        .rate{
                            text-indent:3px;
                            font-size:10px;
                            color:white;
                            font-weight:500;
                            width:30px;
                            text-align:center;
                            line-height:18px;
                            white-space: nowrap;
                        }
                        .stock{
                            font-size: 10px;
                            font-family: PingFang SC;
                            font-weight: 400;
                            color: #F44D41;
                            width:60px;
                            line-height:18px;
                            text-align:center;
                            padding-right:1px;
                        }
                    }
                    .bottom-box{
                        display:flex;
                        margin-top:6px;
                        .price-box{
                            flex:1;
                            span{
                                display:block;
                                width:100%;
                                text-align:left;
                            }
                            .price-now{
                                margin-top:2px;
                                font-size:16px;
                                font-weight: 600;
                                color: #EA1F43;
                                line-height:16px;
                            }
                            .price-prev{
                                font-size: 10px;
                                line-height:10px;
                                font-weight: normal;
                                text-decoration: line-through;
                                color: #B9BFCE;
                            }
                        }
                        .btn{
                            width:61px;
                            height:30px;
                            background-image: url('../../../assets/hot-btn.png');
                            background-size: 100% 100%;
                            font-size: 12px;
                            font-family: PingFang SC;
                            font-weight: 600;
                            text-align:center;
                            line-height:30px;
                            color:#FFF1F1;
                        }
                    }
                }

            }
        }
    }
</style>